import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { basePort, setTokenHeader, headers, isExpiredJwt, getJwtFromCookies, renderRedirect } from "../../module_auth/AuthService"
import { getUniqLogoUrl } from '../common/BaseUtil';
import { AlertWarn } from "../../component/common/Alert"
import {LOGO_URL_PREFIX} from '../../Config'
import { useNavigate } from "react-router-dom";
import parse from 'html-react-parser';
import { CheckAndShowLogo } from "../../component/common/Logo"

export function MbrCpMypage() {
    const navigate = useNavigate();

    const [cpName, setCpName] = useState("");
    const [cpAddress, setCpAddress] = useState("");
    const [cpIntro, setCpIntro] = useState("");
    const [fullname, setFullname] = useState("");
    const [telno, setTelno] = useState("");
    const [mobileNo, setMobileNo] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordRepeat, setPasswordRepeat] = useState("");
    
    // 기업회원가입시 사업자승인이 필요함
    const [validMbr, setValidMbr] = useState("");

    // 인사담당자정보
    const [recruiterName, setRecruiterName] = useState("");
    const [recruiterTelno, setRecruiterTelno] = useState("");
    const [recruiterEmail, setRecruiterEmail] = useState("");

    const [redirect, setRedirect] = useState(false);
    const [accessToken, setAccessToken] = useState("");
    const [memberEntity, setMemberEntity] = useState("");

    //logo
    const [logoEntity, setLogoEntity] = useState(null);

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");
    //modal
    const [showModal, setShowModal] = useState(false);

    const [showAlertWarn, setShowAlertWarn] = useState(false);
    const [alertWarnMessage, setAlertWarnMessage] = 
        useState("사업자등록증과 대표님 신분증 사본을 이메일(gkoosoft@gmail.com)로 제출해주세요. 확인후 승인이 되면 구인 게재가 가능합니다.");

    useEffect(() => {
        if(getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())){
            //alert
            setRedirect(true)
        } else {
            setAccessToken(getJwtFromCookies())
            setTokenHeader(getJwtFromCookies())
            fetch(basePort + '/get/cp/mypage', 
                {method:'GET', headers,
                body:JSON.stringify()})
                .then(response => response.json())
                .then(response => {
                    setCpName(response.cpName)
                    setCpAddress(response.cpAddress)
                    setCpIntro(response.cpIntro)
                    console.log("response.cpIntro: " + response.cpIntro)
                    setFullname(response.fullname)
                    setTelno(response.telno)
                    setMobileNo(response.mobileNo)
                    setEmail(response.email)
                    setRecruiterName(response.recruiterName)
                    setRecruiterTelno(response.recruiterTelno)
                    setRecruiterEmail(response.recruiterEmail)
                    setValidMbr(response.validMbr)
                    if(response.validMbr == 0){
                        setShowAlertWarn(true)
                    } else {
                        setShowAlertWarn(false)
                    }
                    setLogoEntity(response.logoEntity)
            }).catch(error => console.log(error))
        }
    }, []);

    function handlePassword(event) {
        setPassword(event.target.value);
    }

    function handlePasswordRepeat(event) {
        setPasswordRepeat(event.target.value);
    }

    function handleEmail(event) {
        setEmail(event.target.value);
    }

    function handleTelno(event) {
        setTelno(event.target.value);
    }

    function handleMobileNo(event) {
        setMobileNo(event.target.value);
    }

    function handleCpName(event) {
        setCpName(event.target.value);
    }

    function handleCpAddress(event) {
        setCpAddress(event.target.value);
    }

    function handleFullname(event) {
        setFullname(event.target.value);
    }

    function handleCpIntro(event) {
        setCpIntro(event.target.value);
    }

    function handleRecruiterName(event) {
        setRecruiterName(event.target.value);
    }

    function handleRecruiterTelno(event) {
        setRecruiterTelno(event.target.value);
    }

    function handleRecruiterEmail(event) {
        setRecruiterEmail(event.target.value);
    }
    
    function moveTo() {
        let url = "/mbr_cp_modi_mypage"
        navigate(url);
    }

    function clickSubmit(event) {
        moveTo()
    }

    return (
        <div>
            {renderRedirect(redirect, '/login')}
            <main class="page lanidng-page" >
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>마이페이지</span></li>
                            <li class="breadcrumb-item"><span>기업회원정보</span></li>
                        </ol>
                        {/* 기업정보 */}
                        <div class="card" style={{marginBottom: '10px'}}>
                            <div class="card-body" style={{marginBottom: '10px'}}>
                                <AlertWarn show={showAlertWarn} msg={alertWarnMessage} />
                                <form style={{marginTop: '10px'}}><label class="form-label">이메일(아이디):</label><input class="form-control" type="text" value={email} disabled/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">회사명:</label><input class="form-control" type="text" value={cpName} onChange={handleCpName} disabled/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">회사주소:</label><input class="form-control" type="text" value={cpAddress} onChange={handleCpAddress} disabled/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">대표자명:</label><input class="form-control" type="text" value={fullname} onChange={handleFullname} disabled/></form>
                                <form style={{marginTop:'10xp', margin: '10px', marginRight: '0', marginLeft: '0'}} >
                                    <label class="form-label">회사소개:</label>
                                    <div className="card" style={{marginBottom: '50px', backgroundColor: '#e9ecef', color: '#212529', pointerEvents: 'none', opacity: '1'}}>
                                        <div className="card-body">
                                            {cpIntro === null ? "" : parse(cpIntro)}
                                        </div>
                                    </div>
                                </form>
                                <form style={{ marginTop: "20px" }}>
                                    <div className="row">
                                        <label className="form-label">회사 로고:</label>
                                    </div>
                                    {logoEntity && (
                                        <CheckAndShowLogo
                                            imageUrl={getUniqLogoUrl(logoEntity.uniqFileName, logoEntity.fileFormat)}
                                            alt="유효한 이미지"
                                            imageAlign="left"
                                        />
                                    )}
                                </form>
                                <form style={{marginTop: '10px'}}><label class="form-label">전화번호:</label><input class="form-control" type="text" value={telno} onChange={handleTelno} disabled/></form>
                                {/* <form style={{marginTop: '10px'}}><label class="form-label">휴대폰번호:</label><input class="form-control" type="text" value={mobileNo} onChange={handleMobileNo} disabled/></form>
                                <form style={{marginTop: '20px'}}><label class="form-label">인사담당자명:</label><input class="form-control" type="text" value={recruiterName} onChange={handleRecruiterName} disabled/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">인사담당자 전화번호:</label><input class="form-control" type="text" value={recruiterTelno} onChange={handleRecruiterTelno} disabled/></form>
                                <form style={{marginTop: '10px'}}><label class="form-label">인사담당자 이메일:</label><input class="form-control" type="text" value={recruiterEmail} onChange={handleRecruiterEmail} disabled/></form> */}
                                <form style={{marginTop: '10px'}}><label class="form-label">비밀번호:</label><input class="form-control" type="text" value={"*******"} disabled/></form>
                            </div>
                            <form style={{textAlign: 'center', marginBottom: '10px'}}><button class="btn btn-primary" type="button" onClick={clickSubmit}>수정하기</button></form>
                        </div>
                    {/* end of container */}
                    </div>
                </section>
            </main>
        </div>
    );
}